import * as fromCourse from './course.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Event } from './model/event.model';

const { selectEntities, selectAll } = fromCourse.courseAdapter.getSelectors();

export const selectCourseState = createFeatureSelector<fromCourse.State>(fromCourse.courseFeatureKey);

export const selectAllCourses = createSelector(selectCourseState, selectAll);

export const selectCourseEntities = createSelector(selectCourseState, selectEntities);

export const selectCourseById = (id: number) => createSelector(selectCourseEntities, (entities) => entities[id]);

export const selectCourseByName = (searchString: string) =>
    createSelector(selectAllCourses, (entities) => entities.filter((entity) => entity.name?.toLowerCase().includes(searchString.toLowerCase())));

export const selectCoursesByEvents = (events: Event[]) => {
    return createSelector(selectAllCourses, (entities) =>
        entities.filter((entity) => {
            return events.some((event) => event.course?.id === entity.id);
        })
    );
};
